import { Injectable } from '@angular/core';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { EnvService } from '../../client/app/configuration/env.service';

interface IBrowserInfo {
    browser: string;
    minVersion: number;
}

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    supportedBrowsers: IBrowserInfo[] = [];

    constructor(private readonly deviceDetectorService: DeviceDetectorService, private readonly env: EnvService) {}

    private getSupportedBrowsers(): IBrowserInfo[] {
        if (!this.supportedBrowsers || this.supportedBrowsers.length === 0) {
            this.supportedBrowsers = [];
            Object.keys(this.env.config.supportedBrowsers).forEach(key =>
                this.supportedBrowsers.push({
                    browser: key,
                    minVersion: this.env.config.supportedBrowsers[key].minVersion
                })
            );
        }

        if (!this.supportedBrowsers) {
            throw new Error('Supported browser is undefined');
        }
        if (this.supportedBrowsers.length === 0) {
            throw new Error('Supported browser is empty');
        }

        return this.supportedBrowsers;
    }

    getDeviceInfo(): DeviceInfo {
        return this.deviceDetectorService.getDeviceInfo();
    }

    isBrowserSupported(browser: string): boolean {
        const supportedBrowsers = this.getSupportedBrowsers();
        for (const browserConfig of supportedBrowsers) {
            if (browserConfig.browser.toLowerCase() === browser.toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    getMinimalSupportedVersion(browser: string): number {
        const supportedBrowsers = this.getSupportedBrowsers();
        for (const browserConfig of supportedBrowsers) {
            if (browserConfig.browser.toLowerCase() === browser.toLowerCase()) {
                return browserConfig.minVersion;
            }
        }
        throw new Error(`Browser ${browser} was not found in the supported browsers config`);
    }

    isBrowserCompatible(): boolean {
        const deviceInfo = this.getDeviceInfo();
        const userBrowser = deviceInfo.browser;
        if (!this.isBrowserSupported(userBrowser)) {
            return false;
        }
        const userBrowserVersion = Math.floor(parseInt(deviceInfo.browser_version));
        const minVersion = this.getMinimalSupportedVersion(userBrowser);
        if (userBrowserVersion < minVersion) {
            return false;
        }
        return true;
    }
}
